import React from 'react'

import Icon from '@scoir/components-core/dist/components/Icon'
import cn from 'classnames'
import forumIcon from 'icons/forum.svg'
import forumIconLight from 'icons/forum_light.svg'
import PropTypes from 'prop-types'

import './index.scss'

export default class DirectMessaging extends React.Component {
  static propTypes = {
    theme: PropTypes.oneOf(['dark', 'light']),
    hasUnreadMessage: PropTypes.bool.isRequired,
  }
  static defaultProps = {
    theme: 'dark',
  }

  render() {
    const classNames = cn('direct-messaging-comp', {
      [`${this.props.theme}-skin`]: this.props.theme,
    })
    return (
      <span className={classNames}>
        <Icon
          def={this.props.theme === 'light' ? forumIconLight : forumIcon}
          className="messaging-icon"
        />
        {this.props.hasUnreadMessage && <i className="new-message-icon"></i>}
      </span>
    )
  }
}
